import React from 'react';

interface TranscriptionDisplayProps {
  text: string;
  language: string;
}

const TranscriptionDisplay: React.FC<TranscriptionDisplayProps> = ({
  text,
  language,
}) => {
  return (
    <div className="bg-white rounded-lg p-4 shadow-md flex flex-col min-h-[200px]">
      <div className="flex justify-between items-center mb-3 pb-2 border-b-2 border-gray-100">
        <h3 className="text-xl font-semibold text-gray-800 m-0">Transcription</h3>
        <span className="bg-primary-500 text-white px-3 py-1 rounded text-xs font-semibold">
          {language.toUpperCase()}
        </span>
      </div>
      <div className="flex-1 overflow-y-auto">
        {text ? (
          <p className="text-gray-800 text-base leading-relaxed m-0 whitespace-pre-wrap break-words">
            {text}
          </p>
        ) : (
          <p className="text-gray-400 italic text-center mt-8">
            Transcribed text will appear here...
          </p>
        )}
      </div>
    </div>
  );
};

export default TranscriptionDisplay;


